import React from "react";

import { ApprovalStatus } from "../../types/approval-status/approval-status.type";
import { APPROVAL_STATUS } from "../../types/approval-status/approval-status.enum";

import { withShowIf } from "../with-show-if/with-show-If.component";

import { ApprovedMarker, DraftMarker } from "./index.styles";

export interface StatusMarkerProps {
  status: ApprovalStatus;
}

export const StatusMarker = withShowIf((props: StatusMarkerProps) => {
  return (
    <div className="status-marker">
      {props.status === "approved" && <ApprovedMarker>{APPROVAL_STATUS.APPROVED}</ApprovedMarker>}
      {props.status === "draft" && <DraftMarker>{APPROVAL_STATUS.DRAFT}</DraftMarker>}
      {props.status === "in_progress" && <DraftMarker>{APPROVAL_STATUS.IN_PROGRESS}</DraftMarker>}
      {props.status === "work_can_start" && (
        <DraftMarker>{APPROVAL_STATUS.WORK_CAN_START}</DraftMarker>
      )}
      {props.status === "ready_for_creative_review" && (
        <DraftMarker>{APPROVAL_STATUS.READY_FOR_CREATIVE_REVIEW}</DraftMarker>
      )}
    </div>
  );
});
